import { css } from 'emotion';

export const activityHeader = theme => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 69px;
  border-bottom: 1px solid ${theme.color.grey3};
  padding: 0 23px;
`;

export const activityHeaderText = theme => css`
  color: ${theme.color.black1};
  font-size: 20px;
  font-weight: 600;
`;

export const closeButton = css`
  padding: 8px;

  svg {
    height: 16px;
    width: 16px;
  }
`;
